import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function withScrollToTop(WrappedComponent) {
  return function (props) {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location.pathname]);

    return <WrappedComponent {...props} />;
  };
}

export default withScrollToTop;